export enum FileTransferStatus {
  Online = "Online",
  Offline = "Offline",
}
